export default {
  improvementplans: {
    title: '개선 계획',
    high: '고',
    middle: '중',
    low: '저',
    exceed: '초과',
    policy: '규범・방침',
    measure: '시책',
    result: '결과',
    currently_supporting: '대응 중',
    completion: '완료',
    ended: '종료(미대응)',
    risk: '리스크 정도',
    thema: "@:{'common.esg.category'}",
    improvement_plan: '개선 계획',
    deadline_for_completion: '완료 기한',
    message_count: '메시지',
    operation: '조작',
    detail: "@:{'common.scorecard.detail'}",
    indicator: '지표',
    indicator_point: '개선점이',
    buyer_indicator_point: '평가 코멘트',
    status: '상태',
    supported: '대응 완료',
    unsupported: '미대응',
    progress: '진척 상황',
    advice: {
      text_line_1: '이번 평가를 통하여 더 좋은 ESG 대응을 추진합시다.',
      text_line_2: '',
      text_line_3: '대응 내용과 완료 기일을 설정할 수 있습니다.',
      text_line_4: '개선 계획을 세우고, 다음 평가를 위해 대응합시다.',
      text_line_5: '진척 상황은 좌측 그래프에서 확인할 수 있습니다.',
      text_line_6: '재평가를 의뢰하는 경우는 ',
      contact: '문의하기',
      please_contact_us: '에서 상담해 주세요.',
    },
    sub_section_title_1: '대응 중인 개선 계획',
    no_data_display: '표시할 수 있는 데이터가 없습니다.',
    // sub_section_title_2: "",
    buyer_sub_section_title_2: '미대응인 평가 코멘트',
    operation_link_text: '개선 계획 작성',
    // add_advice: "",
    // sub_section_title_3: "",
    buyer_sub_section_title_3: '대응 완료인 평가 코멘트',
    // revaluation_request: "",
    cautionary_note: '완료한 개선 계획을 고려하여 재평가를 의뢰하시겠습니까?',
    asterisked_text: '※재평가를 의뢰하려면 문의하기 화면에서 별도로 신청해야 합니다.',
    submit_btn_text: '재평가 의뢰하기',
    table_state: 'tableState',
    select_a_file: '파일 선택',
    attached_file: '첨부 파일',
    notes: '비고',
    created_improvement_plan: '개선 계획을 작성했습니다.',
    error_file_upload: '파일 업로드로 인한 오류가 발생했습니다.',
    failed_to_create: '개선 계획의 작성에 실패했습니다. 화면을 다시 불러온 후 시도해 주세요.',
    no_data_found: '개선점의 데이터를 찾을 수 없습니다.',
    file_upload: {
      filesize_max: '10MB 이하의 파일을 선택해 주세요.',
      max_files: '업로드는 최대 10건입니다.',
      confirmation_of_deletion: '이 파일을 삭제하시겠습니까?',
    },
    // create_improvement_plan: "",
    no_data_improvement_plan: '대응이 필요한 개선 계획은 현재 없습니다',
  },
  buyer_improvementplans: {
    flag: '플래그',
    memo: '메모',
    flag_on: '플래그 달기',
    flag_off: '플래그 떼기',
    panel: {
      title: '기업 정보・메모',
      company_memo: '사내 메모',
      latest_memo: '최신 메모',
      no_memo: '메모는 아직 없습니다.',
      check_list: '목록 확인',
      memo_list: '메모 목록',
      // no_assignee: "",
      assignee_select_box: {
        // assignee: "",
        // placeholder: "",
        // create_member: "",
      },
      create_member_modal: {
        // title: "",
        // label: "",
        // place_holder: "",
      },
      delete_member_modal: {
        // title: "",
        // confirm_text: "",
        delete_button_label: "@:{'improvement_plans_detail.chat.delete_confirm.delete_button_label'}",
      },
    },
    back_to_list: '목록으로 돌아가기',
    action_cases: '대응 건수',
    no_improvements: '개선점이 없습니다',
    confirm_delete_memo: '사내 메모 1건을 삭제하시겠습니까?',
    confirm_delete_memo_title: '사내 메모 삭제하기',
    // display_only_is_marked: "",
    create_memo: '메모 작성',
  },
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
    },
  },
}
